import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-employee-kpi',
  templateUrl: './employee-kpi.component.html',
  styleUrls: ['./employee-kpi.component.css']
})
export class EmployeeKpiComponent implements OnInit {

  constructor(private employeeService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  output:any=[];
  department:any=[];
  usertype=null
  Date=""
  userTypes: any[] = [];

  baseUrl=this.employeeService.ReturnBase();
  getUrl=this.baseUrl+'viewEmployees';
  deptUrl=this.baseUrl+'viewDepartments/department_dropdown';
  empUrl=this.baseUrl+'viewEmployees/employee_list/department?department=';
  searchEmployeeUrl=this.baseUrl+'viewEmployees?employee_name=';

  isShownEmployee=false
  count=0;
  search: string = '';
  selectedDept = "";
  employee:any=[];
  searchFlag=0
  Role=null;
  loaderShown=true;
  CardShown=false;

  //------routing to edit page--------------------
    
  EditEmployee(Id:any,Type:any){ 
    let data={
      "Id":Id,
      "Type":Type
    }
    this.router.navigate(['admin/employee-kpi-edit'],{queryParams:{setData:JSON.stringify({data})}}); 
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  //---------------------function for select role---------------------
  RoleSelected(value:any){
    console.log("Dept=",this.selectedDept)

    if(value=="0")
    this.Role=null
    else
    this.Role=value
  
    this.Search()


  }

  //excel Export For CustomerKyc
  excelExport() {
    var orderTable = document.getElementById('employee_kpi');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });

    return XLSX.writeFile(wb, ('Employee_Kpi.' + ('xlsx')));


  }
 
  //-------------function for search--------------------
Search(){
  console.log("this.selectedDept=",this.selectedDept)
  var searchData=""
  if(this.Role!=null){
    searchData="&user_type="+ this.Role
  }
   if(this.selectedDept!=""){
    searchData= searchData+"&department_id="+this.selectedDept
  }
  if(this.search!=''){
    searchData= searchData+"&employee_name="+this.search
  }
  
  console.log("dept data===","month_filter="+this.Date+searchData)
  this.employeeService.EmployeeKpi("month_filter="+this.Date+searchData).subscribe((res)=>{
    this.output=res.data
    console.log("Employee details =",this.output)
    this.loaderShown=false;
    this.CardShown=true;

  })
  
}
  //------function for routing-------------------------

  employeeDetails(){
  this.router.navigateByUrl(('admin/employee-kpi-details')); 
  document.body.scrollTop = document.documentElement.scrollTop = 0; 
}

//--------function which give name of selected item---------
getValue = (item : string) =>{
   
  this.employeeService.setEmployeeId(item)
  console.log("error=",item)

}

  //---------for select a particular department----------
  
	onSelected(value:string): void {

    if(value=="0")
		this.selectedDept = "";
   else
   this.selectedDept = value
    this.Search()
	}

  onSelecteDate(){
    console.log("Date =",this.Date) 
    this.Search()

  }

   getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear(); // Get the current year
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1 and ensure two digits
    return `${year}-${month}`;
  }
  
  ngOnInit(): void {

    this.employeeService.usertypeDropdown().subscribe((res) => {
  this.userTypes = res.data;
});


    this.Date=this.getFormattedDate();
   // this.selectedTeam='ALL'
    //-------api get()calling-------------
    this.employeeService.EmployeeKpi("month_filter="+this.Date).subscribe((res)=>{
      this.output=res.data
      console.log("Employee details =",this.output)
      this.loaderShown=false;
      this.CardShown=true;

    })

    //-------api for get department name---------

    this.employeeService.getData(this.deptUrl).subscribe((res)=>{
      this.department=res.data
      console.log("Department details =",this.department)

    })


  }

}
function clicks() {
  throw new Error('Function not implemented.');
}


